module.exports = __webpack_public_path__ + "img/toxis_horizontal.4bac0681.png";